module.exports = __webpack_public_path__ + "static/media/RobotoMono-Light.c9166464.ttf";